/* tslint:disable */
export var icon = "\n<svg width=\"8\" height=\"8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"4\" cy=\"4\" r=\"4\" fill=\"#3FD569\"/></svg>\n";
//# sourceMappingURL=green-dot.svg.js.map